import Layout from '@/layout';

const menuRouter = [
    {
        path: "/",
        component: () => import("@/views/home/index.vue"),
        meta: { auth: 65536 },
        name: "首页",
    },
];

export default [
    {
        path: "/",
        component: Layout,
        children: [...menuRouter]
    }
];